export const GTM_ERRORS = Object.freeze({
  PROVIDER_NOT_RESPONDING:                'PROVIDER_NOT_RESPONDING',
  NO_ADDRESS:                             'NO_ADDRESS',
  INVALID_EMAIL:                          'INVALID_EMAIL',
  INVALID_PASSWORD:                       'INVALID_PASSWORD',
  EMAIL_TAKEN:                            'EMAIL_TAKEN',
  INVALID_PHONE:                          'INVALID_PHONE',
  PHONE_TAKEN:                            'PHONE_TAKEN',
  ALREADY_HAS_AN_ACCOUNT:                 'ALREADY_HAS_AN_ACCOUNT',
  PLAYER_CLICKED_DEPOSIT_LIMITS:          'PLAYER_CLICKED_DEPOSIT_LIMITS',
  UNDER_AGE:                              'UNDER_AGE',
  INVALID_POSTCODE:                       'INVALID_POSTCODE',
  DISABLED_PASSWORD_CLICK:                'DISABLED_PASSWORD_CLICK',
  UNSUPPORTED_PROVINCE:                   'UNSUPPORTED_PROVINCE',
  // ES Live Password Validation alerts
  INVALID_PASSWORD_SIMPLE_PATTERN:        'INVALID_PASSWORD_SIMPLE_PATTERN',
  INVALID_PASSWORD_PERSONAL_DETAILS:      'INVALID_PASSWORD_PERSONAL_DETAILS',
  INVALID_PASSWORD_UNTICKED_REQUIREMENTS: 'INVALID_PASSWORD_UNTICKED_REQUIREMENTS',
  VALID_PASSWORD:                         'VALID_PASSWORD',
});

export const GTM_ACTIONS = Object.freeze({
  FAIL:                             'fail',
  ADDRESS:                          'address',
  NATIONALITY:                      'nationality',
  SHOW_NATIONALITY_DRAWER:          'show_nationality_drawer',
  WELCOME_OFFER:                    'welcome_offer',
  SHOW_BONUS_TERMS:                 'show_bonus_terms',
  SHOW_SPORT_BONUS_TERMS:           'show_sport_bonus_terms',
  SHOW_PRIVACY_POLICY:              'show_privacy_policy',
  SHOW_COOKIES_POLICY:              'show_cookies_policy',
  SHOW_TERMS:                       'show_terms',
  DEPOSIT_AMOUNT_CLICK:             'deposit_amount_click',
  DEPOSIT:                          'deposit',
  ALERT:                            'alert',
  LIMIT_UPDATE:                     'deposit_limit_update',
  LIMITS:                           'limits',
  BIRTH_DETAILS:                    'birth_details',
  MARKETING_CONSENT:                'marketing_consent',
  ACCOUNT_DETAILS:                  'account_details',
  TIME_SPENT:                       'time_spent',
  REGISTRATION_START:               'registration_start',
  REGISTRATION_DONE:                'registration_done',
  REGISTRATION_FAILED:              'registration_failed_callback',
  REGISTRATION_CLOSED:              'registration_closed',
  COUNTRY_OF_RESIDENCE:             'country_residence',
  SHOW_COUNTRY_OF_RESIDENCE_DRAWER: 'show_country_residence_drawer',
  GO_TO_LOGIN:                      'go_to_login',
  PLACES_API_REQUEST_SENT:          'places_api_request_sent',
  PLACES_API_RESPONSE_RECEIVED:     'places_api_response_received',
  PLACES_SELECTED_ADDRESS:          'places_selected_address',
  BANK_ID_REDIRECT:                 'bankid_redirect',
  PNP_TRUSTLY_CLICK_START:          'pnp_trustly_click_start',
  PNP_START_SCREEN:                 'pnp_start_screen',
  PNP_TRUSTLY_DONE:                 'pnp_trustly_done',
  PNP_REGISTRATION_FAILED_CALLBACK: 'pnp_registration_failed_callback',
  PNP_AUTO_LOGIN_DONE:              'pnp_auto_login_done',
  DEPOSIT_LIMITS:                   'deposit_limits',
});

export const PNP_TRUSTLY_DECLINED_REASONS = Object.freeze({
  NOT_APPLICABLE:            'N/A',
  ID_VERIFICATION_FAILED:    'id_verification_failed',
  PNP_DEPOSIT_LIMIT_REACHED: 'pnp_deposit_limit_reached',
  UNIQUE_PLAYER:             'unique_player',
  USER_UNDER_AGE:            'user_under_age',
  PNP_DEPOSIT_UNSUCCESSFUL:  'pnp_deposit_unsuccessful',
  UNSUPPORTED_COUNTRY_CODE:  'unsupported_country_code',
  ACCOUNT_BLOCKED:           'account_blocked',
  REGISTRATION_TIMED_OUT:    'registration_timed_out',
  TRANSACTION_REFUNDED:      'transaction_refunded',
  USER_CANCELED:             'user_canceled',
});

export const GTM_FEATURES = Object.freeze({
  REGISTER: 'register',
});

export const GTM_BASE = Object.freeze({
  TOPIC: 'analytics',
  KIND:  'gtm',
});

export const GTM_PAYLOAD = Object.freeze({
  YES:                  'yes',
  NO:                   'no',
  TRUE:                 'true',
  FALSE:                'false',
  SELECT_WELCOME_OFFER: 'select_welcome_offer',
  DEPOSIT:              'deposit',
  LIMIT_STEP:           'limit',
  DEPOSIT_TOO_HIGH:     'deposit_too_high',
  DEPOSIT_TOO_LOW:      'deposit_too_low',
  DAILY:                'daily',
  WEEKLY:               'weekly',
  MONTHLY:              'monthly',
  NEAR_BY_SEARCH:       'near_by_search',
  DEPOSIT_REQUIRED:     'deposit_required',
  LOGGED_OUT:           'Logged-Out',
  REGISTRATION_FLOW:    'registration_flow',
});

export const GTM_PARAMS = Object.freeze({
  DEPOSIT_LIMIT_DEFINED: 'deposit_limit_defined',
});

export const KEYCLOAK_ADDRESS_KEYS = Object.freeze([
  'address_street_name',
  'address_postal_code',
  'address_country',
  'address_city',
  'nationality',
]);

export const REGISTRATION_FLOW_STEPS = Object.freeze({
  WELCOME_OFFER_STEP:     'welcome_offer_step',
  DEPOSIT_STEP:           'deposit_step',
  LIMITS_STEP:            'limits_step',
  ACCOUNT_DETAILS_STEP:   'account_details_step',
  NATIONALITY_STEP:       'nationality_step',
  MARKETING_CONSENT_STEP: 'marketing_consent_step',
  COUNTRY_RESIDENCE_STEP: 'country_residence_step',
  FULL_NAME_NATIONALITY:  'fullname_nationality',
  BIRTH_DETAILS_STEP:     'birth_details_step',
  ADDRESS:                'address_step',
  /* NEW_MARKET */
  RESIDENCY_ADDRESS:      'residency_address',
});

export const GTM_INPUT_ALERTS = Object.freeze({
  phoneNumber:       GTM_ERRORS.INVALID_PHONE,
  pass:              GTM_ERRORS.INVALID_PASSWORD,
  email:             GTM_ERRORS.INVALID_EMAIL,
  plainTextPassword: GTM_ERRORS.INVALID_PASSWORD,
});

export const GTM_FOCUS_FIELDS = Object.freeze({
  street: 'street',
});

export const GOOGLE_MAPS_ERRORS_MESSAGE = Object.freeze({
  INVALID_REQUEST:  'This request was invalid',
  NOT_FOUND:        'The place referenced was not found',
  OK:               'The response contains a valid result',
  OVER_QUERY_LIMIT: 'The application has gone over its request quota',
  REQUEST_DENIED:   'The application is not allowed to use the PlacesService',
  UNKNOWN_ERROR:
    'The PlacesService request could not be processed due to a server error.',
  ZERO_RESULTS: 'No result was found for this request',
});

export const GTM_CONSENT_ACTION = Object.freeze({
  generalTerms:       GTM_ACTIONS.SHOW_TERMS,
  privacyNotice:      GTM_ACTIONS.SHOW_PRIVACY_POLICY,
  sportsTerms:        GTM_ACTIONS.SHOW_SPORT_BONUS_TERMS,
  termsAndConditions: GTM_ACTIONS.SHOW_BONUS_TERMS,
  CookiesPolicy:      GTM_ACTIONS.SHOW_COOKIES_POLICY,
  PrivacyPolicy:      GTM_ACTIONS.SHOW_PRIVACY_POLICY,
});
